import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Home, LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { isAuthenticated, role } = useAuth();
  const { isDark } = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center bg-pcc-background py-12 px-4">
      <div className="max-w-md w-full text-center">
        <div className={`w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center ${isDark ? 'bg-red-900/30' : 'bg-red-100'}`}>
          <ShieldAlert size={40} className="text-red-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-pcc-text mb-2">
          Accès non autorisé
        </h1>
        
        <p className="text-pcc-text-muted mb-8">
          {isAuthenticated ? (
            <>
              Votre rôle actuel (<span className="font-semibold">{role}</span>) ne vous permet pas 
              d&apos;accéder à cette page.
            </>
          ) : (
            'Vous devez être connecté pour accéder à cette page.'
          )}
        </p>

        <div className="space-y-3">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="w-full h-12 rounded-xl"
          >
            <Home size={18} className="mr-2" />
            Retour à l&apos;accueil
          </Button>
          
          {!isAuthenticated && (
            <Button
              onClick={() => navigate('/login')}
              className="w-full h-12 bg-pcc-primary hover:bg-pcc-primary-dark text-white rounded-xl"
            >
              <LogIn size={18} className="mr-2" />
              Se connecter
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
